<!--  -->
<template>
  <div
    v-bind:class="{div_ucSideBar:true,sideBarHidden:!ucSetting.stretchStatus}"
    v-show="ucSetting.ucVisibile"
  >

    <a
      class="a_side_bar_stretch"
      @click="_sidebarStretchClickHandler"
    >
      <span v-bind:class="{span_side_to_left:ucSetting.stretchStatus,
      span_side_to_right:!ucSetting.stretchStatus}"></span>
    </a>

    <div class="div_mainContent">
      <UCPOIResult
        v-show="ucSetting.ucPOIResultVisible"
        ref="ucPOIResult"
      ></UCPOIResult>

      <UCRoute
        v-show="ucSetting.ucRouteVisible"
        ref="ucRoute"
      ></UCRoute>

      <UCCollectFolder
        v-show="ucSetting.ucCollectVisible"
        ref="ucCollect"
      ></UCCollectFolder>

    </div>

  </div>
</template>

<script>
import UCPOIResult from "../POISearch/UCPOIResult.vue";
import UCRoute from "../route/UCRoute.vue";
import UCCollectFolder from "../collectFolder/UCCollectFolder.vue";

import { UCModuleItemType } from "./UCSideBarJs.js";
import { UCPOIResultParams } from "../POISearch/UCPOISearchJs";
import { RouteSearchParams } from "../route/UCRouteJs";

export default {
  name: "UCSideBar",
  data() {
    return {
      ucSetting: {
        //组件是否可见
        ucVisibile: false,

        ucPOIResultVisible: false,

        ucRouteVisible: false,

        ucCollectVisible: false,

        stretchStatus: true
      },

      curUCPOIResult: null,

      curUCRoute: null,

      curUCCollect:null,

      curMap: null
    };
  },

  components: {
    UCPOIResult,
    UCRoute,
    UCCollectFolder
  },

  computed: {},

  mounted() {},

  methods: {
    init() {
      this.curUCPOIResult = this.$refs.ucPOIResult;
      this.curUCRoute = this.$refs.ucRoute;
      this.curUCCollect=this.$refs.ucCollect;
      
    },

    showModule(ucItemType, params) {
      this.ucSetting.stretchStatus = true;

      this.ucSetting.ucVisibile = true;

      if (ucItemType === UCModuleItemType.poiResult) {
        if (params) {
          params.curMap = this.curMap;
        }

        this.ucSetting.ucPOIResultVisible = true;
        this.ucSetting.ucRouteVisible = false;
        this.ucSetting.ucCollectVisible = false;

        this.$refs.ucPOIResult.resultParams = params;
        this.$refs.ucPOIResult.init();
      } else if (ucItemType === UCModuleItemType.routeline) {
        this.ucSetting.ucRouteVisible = true;
        this.ucSetting.ucPOIResultVisible = false;
        this.ucSetting.ucCollectVisible = false;

        this.$refs.ucRoute.curMap = this.curMap;
        this.$refs.ucRoute.init(params);
      } else if (ucItemType === UCModuleItemType.userCollect) {
        this.ucSetting.ucRouteVisible = false;
        this.ucSetting.ucPOIResultVisible = false;
        this.ucSetting.ucCollectVisible = true;

        // this.$refs.ucRoute.curMap = this.curMap;
        this.$refs.ucCollect.init(params);
      }
    },



    clearContent() {
      let poiSearchParams = new UCPOIResultParams();
      poiSearchParams.curMap = this.curMap;
      this.$refs.ucPOIResult.resultParams = poiSearchParams;
      this.$refs.ucPOIResult.init();

      let routeParams = new RouteSearchParams();
      this.$refs.ucRoute.curMap = this.curMap;
      this.$refs.ucRoute.init(routeParams);
    },

    hidden() {
      this.ucSetting.stretchStatus = false;
    },

    _sidebarStretchClickHandler() {
      this.ucSetting.stretchStatus = !this.ucSetting.stretchStatus;
    }
  }
};
</script>

<style lang="scss" scoped>
.div_ucSideBar {
  position: absolute;
  width: 337px;
  // height: 83%;
  height: calc(100% - 120px);
  top: 52px;
  bottom: 0px;
  left: 0px;
  background: #fff;
  border-right: 1px solid #aaa;
  transition: left 0.5s ease;
  z-index: 6;
  box-shadow: 1px 0 5px rgba(0, 0, 0, 0.5);
  border-collapse: separate;

  .div_mainContent {
    width: 100%;
    height: 100%;
  }

  .a_side_bar_stretch {
    position: absolute;
    width: 20px;
    height: 40px;
    background: hsla(0, 0%, 100%, 0.6);
    top: 9px;
    right: -22px;
    border: 1px solid #aaa;
    border-left: none;
    cursor: pointer;
    display: block;
    transition: 0.2s;
  }

  .span_side_to_left,
  .span_side_to_right {
    background: url("../../../assets/onlineMap/icon.png") #fff;
    width: 5px;
    height: 9px;
    display: block;
    margin-top: 14px;
    margin-left: 7px;
  }

  .span_side_to_left {
    background-position: -217px -216px;
  }

  .span_side_to_right {
    background-position: -232px -216px;
  }
}

.sideBarHidden {
  left: -337px;
}
</style>
